/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useEventContext } from "./EventDataContext";

export function EventActivateDialog({
  history,
  id,
  active_value,
  show,
  onHide,
}) {
  const context = useEventContext();
  // event Context

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
  }, [id]);

  const activateEvent = async () => {
    const activateUrl = "api/workshops/activate/";

    //edit event post
    const result = await axios.patch(activateUrl + id);
    if (result.data === "success") {
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/events/event-list");
      }, 1000);
    } else {
      //setEditErrorOpen(true);
    }
    // closing delete modal
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Event Activate
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure to activate this event?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={activateEvent}
            className="btn btn-delete btn-elevate"
          >
            Activate
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
